import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  listContainer: {
    height: 433,
    maxHeight: 433,
    overflowY: 'auto',
    overflowX: 'hidden',

    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 241px)',
    },
  },
  articleCountContainer: {
    height: 20,
  },
  numOfArticles: {
    paddingLeft: 5,
    color: theme.palette.primary.main,
  },
  itemCardContainer: {
    // padding: 5,
    margin: '5px 5px 15px 5px',
  },

  imageContainer: {
    position: 'relative',
    maxHeight: '250px',
  },
  image: {
    width: '100%',
    padding: '0 !important',
    zIndex: 1,

    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardBox: {
    margin: theme.spacing(1, 0),
  },
  cardImageButton: {
    textAlign: 'left',
    padding: 0,
  },
  footer: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    borderTop: `1px solid ${theme.palette.base.lightGray}`,
  },
  itemCounter: {
    position: 'absolute',
    right: '10px',
    padding: '10px',
    background: theme.palette.base.red,
    color: theme.palette.base.white,
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    zIndex: 10,
  },
  itemDescription: {
    display: '-webkit-box',
    boxOrient: 'vertical',
    lineClamp: 3,
    wordBreak: 'keep-all',
    overflow: 'hidden',
    color: theme.palette.primary.headerText,
  },
}))

export default styles
